import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';

import Home from './Home';
import ChiSiamo from './ChiSiamo';
import Servizi from './Servizi';
import Contatti from './Contatti';
// import Informazioni from './Informazioni';
import Footer from './Footer';
import DoveSiamo from './DoveSiamo';
// import Cookie from './Cookie';

class App extends Component {
    render() {
        return (
            <Grid container>
                <Home />
                <ChiSiamo />
                <Servizi />
                <DoveSiamo />
                <Contatti />
                {/* <Informazioni /> */}
                <Footer />
                {/* <Cookie /> */}
            </Grid>
        );
    }
}

export default App;